module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/nomination-of-electors-desktop.svg?v=bc27f798";